// extracted by mini-css-extract-plugin
export default {"subcribe":"Banner_subcribe__DM7Y9","sputnik":"Banner_sputnik__OnzJJ","text":"Banner_text__t-tDO","icon":"Banner_icon__Tpf8i"};